import React from 'react';

/**
 * Renders a text title that mixes plain text and emojis, where the plain text
 * is painted with a CSS gradient (via `bg-clip-text text-transparent`) while
 * emojis keep their native color.
 *
 * The default Tailwind trick `bg-gradient-to-r ... bg-clip-text text-transparent`
 * paints the text using the background gradient — but it ALSO turns color emojis
 * transparent (only their outline survives, giving a white-blob look). To keep
 * emojis colored, we split the string into emoji vs non-emoji runs and only
 * apply the gradient classes to the non-emoji runs.
 */
const EMOJI_REGEX = /(\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*)/gu;

export const renderTitleWithEmoji = (text, gradientClass) => {
  if (!text) return null;
  const parts = String(text).split(EMOJI_REGEX).filter(Boolean);
  return parts.map((part, i) => {
    if (EMOJI_REGEX.test(part)) {
      // reset lastIndex because regex has /g flag
      EMOJI_REGEX.lastIndex = 0;
      return (
        <span key={i} className="not-gradient" style={{ WebkitTextFillColor: 'initial', color: 'initial', background: 'none' }}>
          {part}
        </span>
      );
    }
    EMOJI_REGEX.lastIndex = 0;
    return (
      <span key={i} className={gradientClass}>
        {part}
      </span>
    );
  });
};
